<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-tabs
        class="back-content-tabs"
        :default-active-key="selectedTab"
        :active-key="selectedTab"
        :animated="false"
        @change="tabChange"
      >
        <a-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab.title"
        >
          <component :is="tab.component" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </page-header-wrapper>
</template>

<script>
import IncomeDetails from './IncomeDetails.vue'
import IncomeGrowth from './IncomeGrowth.vue'

const settingTabs = [
  {
    title: '统计详情',
    key: 'details',
    component: 'IncomeDetails'
  },
  {
    title: '增长分析',
    key: 'growth',
    component: 'IncomeGrowth'
  }
]

export default {
  components: {
    IncomeDetails,
    IncomeGrowth
  },
  data () {
    return {
      tabs: settingTabs,
      selectedTab: ''
    }
  },
  watch: {
    '$route.query.tab': {
      handler: function (val) {
        this.setSelectedTab()
      }
    }
  },
  created () {
    this.setSelectedTab()
  },
  methods: {
    setSelectedTab () {
      if (this.$route.query && this.$route.query.tab) {
        this.selectedTab = this.$route.query.tab
      } else {
        this.selectedTab = this.tabs[0].key
      }
    },
    tabChange (activeKey) {
      this.$router.push({
        name: 'incomeAnalysis',
        query: {
          tab: activeKey
        }
      })
    }
  }
}
</script>
